import React from 'react'
import SEO from '../../seo/SEO'
import BlogBanner from './BlogBanner/BlogBanner'
import SecondBlog from './SecondBlog/SecondBlog'

const Blogsmain = () => {
  return (
    <>
    <SEO />
    <div>
        <BlogBanner/>
        <SecondBlog/>
    </div>
    </>
  )
}

export default Blogsmain

